import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppGlobals } from '../app.globals';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ConstantsService } from './constants.service';
import { FGAData } from '../fga/models';

@Injectable()
export class DelayedDispatchService {
  private usernameSource = new BehaviorSubject<string | null>(null);  //  NOSONAR
  username$ = this.usernameSource.asObservable(); 
  public details$ = new BehaviorSubject<FGAData>(null);

  constructor(private readonly http: HttpClient, private readonly globals: AppGlobals , private readonly constantsService :ConstantsService) { }
  /**
      * Returns headers in the format that matches the type of HTTP call being made.
      * @returns {any}
      */
  private getHeaders(): any {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': sessionStorage.getItem('JT'),
      'Access-Control-Allow-Origin': '*'
    });
  }


  getExistingAlloProperties(){
    return this.http 
      .get(`${this.constantsService.baseAPIURL}/allo/getproperties`, this.constantsService.httpCustomOptions)


  }

  uploadAlloProperties(Params) {
    
    return this.http.post(`${this.constantsService.baseAPIURL}/allo/uploadproperties`, Params, { headers: new HttpHeaders({ 'Accept': 'application/json' }) } )


  }

  addAlloProperty(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/allo/addproperty`, Params, { headers: this.constantsService.httpOptions})



  }

  updateAlloProperties(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/allo/updateproperties`, Params, { headers: this.constantsService.httpOptions})



  }

  deleteAlloProperties(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/allo/deleteproperties`, Params, { headers: this.constantsService.httpOptions})

   
  }

  exportAlloProperties(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/allo/exportproperties`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })

  }

  getDomiciles() {
    return this.http 
      .get(`${this.constantsService.baseAPIURL}/alloreports/getdomiciles`, this.constantsService.httpCustomOptions)

  }

  getNamcs() {
    return this.http 
      .get(`${this.constantsService.baseAPIURL}/alloreports/getnamcs`, this.constantsService.httpCustomOptions)


  }

  getPeriods() {
    return this.http 
      .get(`${this.constantsService.baseAPIURL}/alloreports/getperiods`, this.constantsService.httpCustomOptions)


  }

  getAlloPlantReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getplantreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })



  }

  getAlloSupplierReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getsupplierreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })


  }

  getAlloDockReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getdockreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })

  }

  getAlloCrossDockReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getcrossdockreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })

  }

  getAlloCalendarReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getcalendarreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })


  }

  getAlloBaselineReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getbaselinereport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })

  }

  getAlloTransporterReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/gettransporterreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })


    
  }

  getAlloPartSupplierDockReport(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloreports/getpartsupplierdockreport`, Params, { headers: this.constantsService.httpOptions,responseType: 'blob' })

 
  }

  addAlloFiscalYear(Params) {
 
    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/addfiscalyear`, Params, { headers: this.constantsService.httpOptions})

  }

  getAlloFiscalYears() {

    return this.http 
      .get(`${this.constantsService.baseAPIURL}/alloapr/getfiscalyears`, this.constantsService.httpCustomOptions)
  }

  addAlloAPRCost(Params) {

    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/addaprcost`, Params, { headers: this.constantsService.httpOptions})

  }

  getAlloAPRCostsOfFiscalYear(Params) {

    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/getaprcosts`, Params, { headers: this.constantsService.httpOptions})


  }

  updateSelectedAPRCosts(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/updateaprcosts`, Params, { headers: this.constantsService.httpOptions})


  }

  deleteSelectedAPRCosts(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/deleteaprcosts`, Params, { headers: this.constantsService.httpOptions})


  }

  copyFiscalYear(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/alloapr/copyfiscalyear`, Params, { headers: this.constantsService.httpOptions})

  }

  getUpdatedAlloProperties() {
    return this.http 
    .get(`${this.constantsService.baseAPIURL}/allo/getupdatedproperties`, this.constantsService.httpCustomOptions)
  }

  getUserReportsHistory() {
    return this.http 
    .get(`${this.constantsService.baseAPIURL}/alloreports/getreportshistory`, this.constantsService.httpCustomOptions)
  }

  getValidateUserRoles() {
    return this.http 
    .get(`${this.constantsService.baseAPIURL}/allo/validateuserroles`, this.constantsService.httpCustomOptions)

  }

  

  uploadRouteSummary(Params) {
    return this.http.post(`${this.constantsService.baseAPIURL}/uploadfile/importroutesummary`, Params, { headers: this.constantsService.httpOptions})
  }

  setUsername(username: string) {
    this.usernameSource.next(username);
  }

  getDetails(): Observable<FGAData> {
		return this.details$.asObservable();
	}

  
}
